var map = {
	"./bk.png": "c6dV",
	"./home.png": "+B9e",
	"./hubin.png": "X2jr",
	"./kesiswaan.png": "pAzO",
	"./kurikulum.png": "muX6",
	"./setting.png": "ysNZ",
	"./sino.png": "50rY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hFzH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu ^\.\/.*\.png$
// module id = hFzH
// module chunks = 1